




























































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import type { Company } from '@/models/company';
import { companyWebservice } from '@/webservices/company';

@Component({
    name: 'KnowledgeSettings',
    components: {},
})
export default class KnowledgeSettings extends Vue {
    // Data
    private disabled: boolean = false;
    private isLoading: boolean = false;
    private errorMsg: string = '';

    private company: Company = {} as Company;

    private loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    @Getter('account/company') private companyData: Company;
    @Getter('utils/currentLocale') private currentLocale: string;

    private mounted() {
        this.load();
    }

    private async load() {
        this.isLoading = true;
        companyWebservice.getCompanyByUser().then((res) => {
            this.company = res.data;
            this.isLoading = false;
        });
    }

    private reload() {
        location.reload();
    }

    private save() {
        this.disabled = true;
        if (!this.validate()) {
            this.disabled = false;
            return false;
        }
        companyWebservice
            .updateKnowledgeSettingsByAdmin(this.company)
            .then(async (response) => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: 'Successfully Updated',
                    type: 'is-success',
                });
                this.reload();
                this.disabled = false;
            })
            .catch((error) => {
                this.disabled = false;
                console.log(error);
            });
    }

    private validate() {
        if (!this.company.name || this.company.name === '') {
            this.errorMsg = 'name';
            return false;
        } else if (!this.company.setting.pm_en_tab_title || this.company.setting.pm_en_tab_title === '') {
            this.errorMsg = 'pm_en_tab_title';
            return false;
        } else if (!this.company.setting.pm_de_tab_title || this.company.setting.pm_de_tab_title === '') {
            this.errorMsg = 'pm_de_tab_title';
            return false;
        } else if (!this.company.setting.pm_en_lesson_title || this.company.setting.pm_en_lesson_title === '') {
            this.errorMsg = 'pm_en_lesson_title';
            return false;
        } else if (!this.company.setting.pm_de_lesson_title || this.company.setting.pm_de_lesson_title === '') {
            this.errorMsg = 'pm_de_lesson_title';
            return false;
        } else if (!this.company.setting.pm_en_process_title || this.company.setting.pm_en_process_title === '') {
            this.errorMsg = 'pm_en_process_title';
            return false;
        } else if (!this.company.setting.pm_de_process_title || this.company.setting.pm_de_process_title === '') {
            this.errorMsg = 'pm_de_process_title';
            return false;
        } else if (
            !this.company.setting.pm_en_sub_process_title ||
            this.company.setting.pm_en_sub_process_title === ''
        ) {
            this.errorMsg = 'pm_en_sub_process_title';
            return false;
        } else if (
            !this.company.setting.pm_de_sub_process_title ||
            this.company.setting.pm_de_sub_process_title === ''
        ) {
            this.errorMsg = 'pm_de_sub_process_title';
            return false;
        } else if (!this.company.setting.x_en_tab_title || this.company.setting.x_en_tab_title === '') {
            this.errorMsg = 'x_en_tab_title';
            return false;
        } else if (!this.company.setting.x_de_tab_title || this.company.setting.x_de_tab_title === '') {
            this.errorMsg = 'x_de_tab_title';
            return false;
        } else if (!this.company.setting.x_en_lesson_title || this.company.setting.x_en_lesson_title === '') {
            this.errorMsg = 'x_en_lesson_title';
            return false;
        } else if (!this.company.setting.x_de_lesson_title || this.company.setting.x_de_lesson_title === '') {
            this.errorMsg = 'x_de_lesson_title';
            return false;
        } else if (!this.company.setting.x_en_process_title || this.company.setting.x_en_process_title === '') {
            this.errorMsg = 'x_en_process_title';
            return false;
        } else if (!this.company.setting.x_de_process_title || this.company.setting.x_de_process_title === '') {
            this.errorMsg = 'x_de_process_title';
            return false;
        } else if (!this.company.setting.x_en_sub_process_title || this.company.setting.x_en_sub_process_title === '') {
            this.errorMsg = 'x_en_sub_process_title';
            return false;
        } else if (!this.company.setting.x_de_sub_process_title || this.company.setting.x_de_sub_process_title === '') {
            this.errorMsg = 'x_de_sub_process_title';
            return false;
        } else {
            return true;
        }
    }
}
